import {
  FlexibleDisplayItem,
  FlexibleDisplaySection,
} from '@chiroup/core/functions/buildFlexibleDisplay';
import { ComplaintSummaryType, QuestionAnswer } from '@chiroup/core/types/ComplaintSummary.type';
import React, { useState } from 'react';
import ComplaintSummarySection from './ComplaintSummarySection';
import FlexibleDisplayItemRenderer from './FlexibleDisplayItemRenderer';

interface InteractiveComplaintSummaryProps {
  complaintId: string;
  sections: FlexibleDisplaySection[];
  questionAnswerMaps?: Record<string, QuestionAnswer>;
  onAnswerChange: (
    questionId: string,
    newValue: string | string[],
    otherValue?: string,
    customInputData?: Record<string, string>
  ) => void;
  isEditable: boolean;
  onSymptomClick?: (
    questionId: string,
    symptomValue: string | string[],
    otherValue?: string,
    customInputData?: Record<string, string>
  ) => void;
  summaryType?: ComplaintSummaryType;
}

const InteractiveComplaintSummary: React.FC<InteractiveComplaintSummaryProps> = ({
  complaintId: _complaintId,
  sections,
  questionAnswerMaps = {},
  onAnswerChange,
  isEditable = true,
  onSymptomClick,
  summaryType,
}) => {
  const [popoverOpen, setPopoverOpen] = useState<Record<string, boolean>>({});

  const handlePopoverOpenChange = (uniqueKey: string, open: boolean) => {
    setPopoverOpen(prev => {
      // Ensure only one popover is open at a time to prevent stacking/overlap
      if (open) {
        return { [uniqueKey]: true };
      }

      const { [uniqueKey]: _closed, ...rest } = prev;

      return { ...rest, [uniqueKey]: false };
    });
  };

  const renderFlexibleDisplayItem = (
    item: FlexibleDisplayItem,
    itemIndex: number,
    sectionTitle?: string
  ) => (
    <FlexibleDisplayItemRenderer
      item={item}
      itemIndex={itemIndex}
      sectionTitle={sectionTitle}
      questionAnswerMaps={questionAnswerMaps}
      isEditable={isEditable}
      popoverOpen={popoverOpen}
      onPopoverOpenChange={handlePopoverOpenChange}
      onAnswerChange={onAnswerChange}
      onSymptomClick={onSymptomClick}
      summaryType={summaryType}
    />
  );

  return (
    <div className="interactive-complaint-summary">
      {sections.map((section, sectionIndex) => (
        <ComplaintSummarySection
          key={sectionIndex}
          section={section}
          sectionIndex={sectionIndex}
          renderFlexibleDisplayItem={(item, itemIndex) =>
            renderFlexibleDisplayItem(item, itemIndex, section.title)
          }
        />
      ))}
    </div>
  );
};

export default InteractiveComplaintSummary;
